import { Rule } from "antd/lib/form"
import i18n from "~Shared/locales/i18n"

export const createSettingsRules = () => ({
    globalCurrency: [{ type: "string", required: true, message: i18n.t("validation:required") }] as Array<Rule>,
})
